import { DataGrid, GridToolbarContainer, GridActionsCellItem } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Button, Dialog, TextField, DialogTitle, Stack, DialogActions, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useContext } from 'react'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { ApiContext } from "../../../App";


const TariffDialog = ({title, setTariffDialogIsOpen, setDialogData, cancelHandler, tariffHandler, t, tariffDialogIsOpen, dialogData, setErrorMessages, errorMessages, tariffRows}) => {
    const formHandler = () => {

        const errors = {}

        if (dialogData.name === ""){
            errors['name'] = t("Name must have a value")
        } else {
            const tariffRow = tariffRows.find((tariff) => tariff.name === dialogData.name)
            if (tariffRow &&  tariffRow.url !== dialogData.url){
                errors['name'] = t("A tariff of that name already exists")
            }
        }

        if (dialogData.price_engine === ""){
            errors['price_engine'] = t("Price engine must have a value")
        }   

        if (['fixed', 'day_night'].includes(dialogData.price_engine)) {
            if (dialogData.value == "") {
                errors['value'] = t("Value must have a value")
            }
        }
        
        if (dialogData.price_engine === "day_night"){
            if (!dialogData.night_value){
                errors['night_value'] = t("You must define a night value for day/time rate.")
            }
            if (!dialogData.day_tariff_start_time){
                errors['day_tariff_start_time'] = t("You must define a start time for day/time rate.")
            }
            if (!dialogData.day_tariff_end_time){
                errors['day_tariff_end_time'] = t("You must define an end time for day/time rate.")
            }
            if(dialogData.day_tariff_end_time < dialogData.day_tariff_start_time) {
                errors['day_tariff_end_time'] = t("Tariff end time must be after start time")
            }
        }

        setErrorMessages(errors)
        if(Object.keys(errors).length == 0) {
            tariffHandler()
        }
    }

    const tariffChangeHandler = (event) => {

        
        if  (['octopus', 'epias', 'epias_gas'].includes(event.target.value)) {
            setDialogData({
                ...dialogData, 
                price_engine: event.target.value,
                value: null,
                night_value: null,
                day_tariff_start_time: null,
                day_tariff_end_time: null
            })
        } else if (event.target.value === "fixed") {
            setDialogData({
                ...dialogData, 
                price_engine: event.target.value,
                night_value: null,
                day_tariff_start_time: null,
                day_tariff_end_time: null
            })
        } else {
            setDialogData({ ...dialogData, price_engine: event.target.value })
        }
    }

    const price_engines = ['fixed', 'day_night', 'octopus', 'epias', 'epias_gas']
    
    return (
        <Dialog
                open={tariffDialogIsOpen}
                onClose={() => setTariffDialogIsOpen(!tariffDialogIsOpen)}
                fullWidth
                maxWidth={"md"}
            >
                <Stack direction='column' spacing={2} sx={{ paddingLeft: '5%', paddingRight: '5%' }}>
                    <DialogTitle sx={{ padding: '16px 0px', paddingBottom: '0' }}>{title}</DialogTitle>
                    <TextField
                        style={{ marginTop: '0' }}
                        variant="standard"
                        id="name"
                        label={t("Name")}
                        value={dialogData.name}
                        onChange={(event) => setDialogData({ ...dialogData, name: event.target.value })}
                        error={errorMessages.hasOwnProperty("name")}
                        helperText={errorMessages["name"]? errorMessages["name"]: ""}
                    />
                    <TextField
                        style={{ marginTop: '0' }}
                        variant="standard"
                        id="price_engine"
                        label={t("Price Engine")}
                        value={dialogData.price_engine}
                        onChange={(event) => tariffChangeHandler(event)}
                        error={errorMessages.hasOwnProperty("price_engine")}
                        helperText={errorMessages["price_engine"]? errorMessages["price_engine"]: ""}
                        select
                    >
                        {price_engines.map((price_engine, index) => (
                            <MenuItem value={price_engine} key={index}>
                                {price_engine}
                            </MenuItem>
                        ))}
                    </TextField>
                    { ['fixed', 'day_night'].includes(dialogData.price_engine) && <TextField
                        style={{ marginTop: '0' }}
                        variant="standard"
                        id="value"
                        label={t("Value")}
                        value={dialogData.value}
                        onChange={(event) => setDialogData({ ...dialogData, value: event.target.value })}
                        error={errorMessages.hasOwnProperty("value")}
                        helperText={errorMessages["value"]? errorMessages["value"]: ""}
                    />}
                    {dialogData.price_engine === 'day_night' && 
                    <> 
                    <TextField
                        style={{ marginTop: '0' }}
                        variant="standard"
                        id="night_value"
                        label={t("Night value")}
                        value={dialogData.night_value}
                        onChange={(event) => setDialogData({ ...dialogData, night_value: event.target.value })}
                        error={errorMessages.hasOwnProperty("night_value")}
                        helperText={errorMessages["night_value"]? errorMessages["night_value"]: ""}
                    />
                    <TextField
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                        id="day_tariff_start_time"
                        label={t("Day tariff start time")}
                        type='time'
                        value={dialogData.day_tariff_start_time}
                        onChange={(event) => setDialogData({ ...dialogData, day_tariff_start_time: event.target.value })}
                        error={errorMessages.hasOwnProperty("day_tariff_start_time")}
                        helperText={errorMessages["day_tariff_start_time"]? errorMessages["day_tariff_start_time"]: ""}
                    />
                    <TextField
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                        id="day_tariff_end_time"
                        label={t("Day tariff end time")}
                        type='time'
                        value={dialogData.day_tariff_end_time}
                        onChange={(event) => setDialogData({ ...dialogData, day_tariff_end_time: event.target.value })}
                        error={errorMessages.hasOwnProperty("day_tariff_end_time")}
                        helperText={errorMessages["day_tariff_end_time"]? errorMessages["day_tariff_end_time"]: ""}
                    /> 
                    </>
                    }
                    <DialogActions>
                        <Button onClick={cancelHandler} type="button">Cancel</Button>
                        <Button type="button" onClick={formHandler}>Save</Button>
                    </DialogActions>
                </Stack>
            </Dialog>
    )
}


const TariffTable = ({ facility }) => {
    const { t } = useTranslation();
    const [tariffRows, setTariffRows] = useState([])
    const [tariffDialogIsOpen, setTariffDialogIsOpen] = useState(false)
    const [errorMessages, setErrorMessages] = useState({})
    const [dialogTitle, setDialogTitle] = useState('')
    const [dialogData, setDialogData] = useState({
        name: '',
        price_engine: '',
        value: null,
        night_value: null,
        day_tariff_start_time: null,
        day_tariff_end_time: null
    })

    const {tariffApi} = useContext(ApiContext)

    useEffect(() => {
        tariffApi.list(facility, (data) => {
            setTariffRows(data)
        }, () => {
            alert(t("Couldn't get tariff data"))
        })
    }, [facility])

    const columns = [
        {
            field: "name",
            headerName: t("Name"),
            width: 175
        },
        {
            field: "price_engine",
            headerName: t("Price Engine"),
            width: 175
        },
        {
            field: "value",
            headerName: t("Value"),
            width: 175
        },
        {
            field: "night_value",
            headerName: t("Night Value"),
            width: 175
        },
        {
            field: "day_tariff_start_time",
            headerName: t("Day tariff start time"),
            width: 175
        },
        {
            field: "day_tariff_end_time",
            headerName: t("Day tariff end time"),
            width: 175
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: t('Actions'),
            flex: 0.5,
            minWidth: 150,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label={t("Edit")}
                        className="textPrimary"
                        onClick={() => editTariffHandler(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label={t("Delete")}
                        onClick={() => deleteTariff(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ]

    const deleteTariff = (id) => {
        const confirmed = window.confirm(t('Delete this tariff?'))
        if (confirmed) {
            tariffApi.delete(id, () => {
                setTariffRows(tariffRows.filter((row) => row.url !== id))
            }, () => {
                alert(t('Could not delete tariff'))
            })
        }
    }

    const addTariffHandler = () => {
        setTariffDialogIsOpen(!tariffDialogIsOpen)
        setDialogTitle('Add Tariff')
        setDialogData({
            name: '',
            price_engine: '',
            value: '',
            night_value: null,
            day_tariff_start_time: null,
            day_tariff_end_time: null
        })
        setErrorMessages({})
    }

    const editTariffHandler = (id) => {
        setTariffDialogIsOpen(!tariffDialogIsOpen)
        setDialogTitle('Edit Tariff')
        const selectedTariffData = tariffRows.find((row) => row.url == id)
        setDialogData(selectedTariffData)
        setErrorMessages({})
    }

    const cancelHandler = () => {
        setTariffDialogIsOpen(!tariffDialogIsOpen)
    }

    const tariffHandler = () => {
        if (dialogTitle == 'Add Tariff'){
            const enrichedData = {...dialogData, facility: facility}
            tariffApi.create({...dialogData, facility: facility}, (data) => {
                setTariffRows([...tariffRows, {...enrichedData, url: data.url}])
                setTariffDialogIsOpen(!tariffDialogIsOpen)
            }, () => {
                alert(t("Couldn't create new tariff"))
            })
        } 
        if (dialogTitle == 'Edit Tariff') {
            tariffApi.update(dialogData.url, dialogData, (data) => {
                setTariffRows(tariffRows.map((row) => row.url == dialogData.url ? dialogData : row ))
                setTariffDialogIsOpen(!tariffDialogIsOpen)
            }, () => {
                alert(t("Couldn't edit tariff"))
            })
        }
    }

    const TariffToolbar = () => {
        return (
            <GridToolbarContainer>
                <Button color="primary" size="small" startIcon={<AddIcon />} onClick={addTariffHandler}>
                    {t("Add Tariff")}
                </Button>
            </GridToolbarContainer>
        )
    }

    return (
        <Box sx={{ height: 400, width: '100%', marginTop: '20px' }}>
            <DataGrid
                columns={columns}
                rows={tariffRows}
                getRowId={(row) => row.url}
                components={{
                    Toolbar: TariffToolbar
                }}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                pageSizeOptions={[5]}
            />
            <TariffDialog title={dialogTitle} setTariffDialogIsOpen={setTariffDialogIsOpen} setDialogData={setDialogData} cancelHandler={cancelHandler} tariffHandler={tariffHandler} t={t} tariffDialogIsOpen={tariffDialogIsOpen} dialogData={dialogData} setErrorMessages={setErrorMessages} errorMessages={errorMessages} tariffRows={tariffRows}/> 
        </Box>
    );
}

export default TariffTable;